import "../css/TopBar.css";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import login from "./login.js";

function TopBar() {

  var location = useLocation();
  var { login } = location.state || {};
  const navigation = useNavigate()
  function clicktologinscreen() {
    navigation('/login', { state: { login } })
  }

   const disableRightClick = (e) => {
    e.preventDefault();
  };


  return (
    <div className="top-bar"   onContextMenu={disableRightClick}>
    
      <label className="name"><b>Already a member?</b></label>
      <button onClick={clicktologinscreen} className="login_button">Login</button>
      <div >

        <b>Need help? Call</b>
        <span>  72007 45891</span>
      </div>

    </div>
  );
};

export default TopBar;
